import { type ReactNode } from 'react';
import { useMedia } from 'react-use';
import { CaretLeft } from '@hungryroot/icons';
import { Heading, Sheet, SheetOrModal } from '@hungryroot/ramen';
import { BreakpointQueryLarge } from '@hungryroot/tokens';

import styles from './SheetOrOverlay.module.css';

interface Props {
  overlayClassName?: string;
  onBackClick: () => void;
  children: ReactNode;
  onRequestDismiss: () => void;
  isActive: boolean;
  testid?: string;
  title?: string;
  showBackButton?: boolean;
  isModalEditor?: boolean;
  childrenClassName?: string;
  contentClassName?: string;
}

export function SheetOrOverlay(props: Props) {
  const {
    testid,
    onBackClick,
    isActive,
    overlayClassName,
    onRequestDismiss,
    children,
    title,
    showBackButton,
    isModalEditor = false,
    childrenClassName,
    contentClassName,
  } = props;
  const isDesktop = useMedia(BreakpointQueryLarge);

  const header = (
    <div className={showBackButton ? styles.header : styles['mobile-header']}>
      {showBackButton && (
        <button
          data-testid={`${testid}-button-back`}
          className={styles.back}
          onClick={onBackClick}
        >
          <CaretLeft />
        </button>
      )}
      {title !== undefined && (
        <Heading variant="H3" testid={`${testid}-heading`}>
          {title}
        </Heading>
      )}
    </div>
  );

  if (!isModalEditor) {
    if (isDesktop === true && isActive === true) {
      return (
        <div className={[styles.overlay, overlayClassName].join(' ')}>
          {header}
          <div className={`${styles.children} ${childrenClassName}`}>
            {children}
          </div>
        </div>
      );
    }

    return (
      <Sheet
        className={styles.sheet}
        initialFocusRef={undefined}
        active={isActive}
        testid={testid}
        ariaLabel="rdp-modal"
        onRequestDismiss={onRequestDismiss}
      >
        {header}
        <div className={`${styles.children} ${childrenClassName}`}>
          {children}
        </div>
      </Sheet>
    );
  }

  return (
    <SheetOrModal
      data-testid={testid}
      onDismiss={onRequestDismiss}
      ariaLabel="edit-pairing-modal"
      testid={`${testid}-modal`}
      isOpen={isActive}
      contentClassName={`${styles['container-modal']} ${contentClassName}`}
      overlayClassName={styles['overlay-modal']}
    >
      {header}
      <div className={`${styles.children} ${childrenClassName}`}>
        {children}
      </div>
    </SheetOrModal>
  );
}
